import React, {useEffect} from 'react';
import {Login} from "./Components/Login";
import 'react-toastify/dist/ReactToastify.css';
import {Notification} from "./features/notification/Notification";
import {useMutation} from "@apollo/client";
import {TokenLogin} from "./GraphQL/LoginMutations";
import {useAppDispatch, useAppSelector} from "./redux/hooks";
import {RootState} from "./redux/store";
import {setUser} from "./redux/slices/user/userSlice";
import {ContentRouter} from "./Components/ContentRouter";
import {LoadingScreen} from "./Atoms/LoadingScreen";
import {setIsAppLoading} from "./redux/slices/content/contentSlice";
import {ActiveContent} from "./redux/slices/content/contentType";
import {Registration} from "./Components/Registration";


export const App = () => {
    const user = useAppSelector((state: RootState) => state.user);
    const content = useAppSelector((state: RootState) => state.content)
    const dispatch = useAppDispatch();

    const [loginViaToken, { data: loginTokenData, loading: loginTokenLoading}] = useMutation(TokenLogin);

    useEffect(() => {
        if (user.userId === 0 && localStorage.getItem('token')) {
            loginViaToken({
                variables: {
                    token: localStorage.getItem('token')
                }
            }).then(() => 'obligatory catch');
        }
    }, [ user.userId ])

    useEffect(() => {
        if (loginTokenData && !loginTokenLoading) {
            if (loginTokenData.loginViaToken.user != null) {
                dispatch(setUser({
                    userEmail: loginTokenData.loginViaToken.user.userEmail,
                    role: loginTokenData.loginViaToken.user.userRole,
                    userName: loginTokenData.loginViaToken.user.userName,
                    userId: loginTokenData.loginViaToken.user.userId,
                    lastPlayedAdventure: loginTokenData.loginViaToken.user.lastPlayedAdventure,
                    lastHostedAdventure: loginTokenData.loginViaToken.user.lastHostedAdventure
                }))
            }
        }
    }, [loginTokenData])

    useEffect(() => {
        dispatch(setIsAppLoading({
            isAppLoading: loginTokenLoading,
            loadingText: loginTokenLoading? 'Sie werden angemeldet' : ''
        }))
    }, [loginTokenLoading])

      return (
        <div className="App">
            { content.isAppLoading && (
                <LoadingScreen/>
            )}
            <Notification/>
            { (user.userId === 0 && content.activeContent !== ActiveContent.Registrierung)? <Login/> : content.activeContent === ActiveContent.Registrierung? <Registration/> : <ContentRouter/> }
        </div>
      );
}

export default App;
